import {
  Box, Flex, Link, Text,
} from '@chakra-ui/react';
import {
  useNetworkAvailabilityKPI,
} from '@src/modules/performance/context/reports-api-hooks';
import { CircleIndicator } from '@src/modules/performance/components/indicators';
import { roundKpiValue } from '@src/modules/performance/shared/helpers';
import ReportHeader from './ReportHeader';

const subheader = 'Resilience and Freight Accessibility';
const informationSource = {
  title: 'Resilience and Freight Accessibility',
  content: [
    {
      title: 'Proportion of Network Accessible to Class 1 and 50MAX',
      description:
  <>
    <Text fontSize="inherit" mb={2}>
      This measure shows the proportion of the network length that is accessible to both Class 1 heavy and 50MAX HPMV vehicles.
    </Text>
    <Text mb={2}>Road Efficiency Group Te Ringa Maimoa has calculated this result.</Text>
  </>,
      source:
  <Text fontSize="inherit" as="span">
    Sourced from Transport Insights.
    {' '}
    Network length sourced from
    {' '}
    <Link href="https://www.nzta.govt.nz/planning-and-investment/learning-and-resources/transport-data/data-and-tools/" isExternal>NZTA, physical statistics - roads</Link>
  </Text>,
    },
  ],
};

function NetworkAvailabilityReportHeader({ ...rest }) {
  const { data: networkAvailabilityData, isLoadingKpi } = useNetworkAvailabilityKPI();

  return (
    <ReportHeader
      title="Network Availability and Accessibility"
      subtitle={subheader}
      informationSource={informationSource}
      {...rest}
    >
      <Flex align="center">
        <Box mr={3}>
          <CircleIndicator
            size={60}
            colour={!networkAvailabilityData?.nodata ? 'gray.700' : null}
            value={!networkAvailabilityData?.nodata ? `${roundKpiValue(networkAvailabilityData?.value, 99.5, 1, 'min')}%` : undefined}
            isLoading={isLoadingKpi || !networkAvailabilityData}
          />
        </Box>
        <Text fontWeight="bold" color="gray" fontSize="sm">
          Proportion of network accessible to
          <br />
          Class 1 and 50MAX vehicles
        </Text>
      </Flex>
    </ReportHeader>
  );
}

export default NetworkAvailabilityReportHeader;
